module.exports = __webpack_public_path__ + "static/media/icon_checkDone.7bcd77e3.svg";